<template>
    <div class="add" v-if="user">
        <div class="submittal" v-if="projects">
            <div>
                <favorite-button v-if="user" :id="id" />
                <a href="/account/favorites">View My Favorites</a>
                <hr>
                <ul>
                    <li v-if="canPrint">
                        <span @click="printPage"><a href="#"> <img class="link-icon" src="/img/icons/print-regular.svg"> Print</a></span>
                    </li>
                    <li v-if="submittalFileUrl">
                        <span v-for="fileUrl in submittalFileUrls">
                            <a :href="fileUrl" class="-download" target="_blank"> <img class="link-icon" src="/img/icons/file-contract-light.svg"> Product Submittal / Data Sheet</a>
                        </span>
                    </li>

                    <template v-if="displayValveConfigurator">
                        <!-- Need VEP only IF statement and final resting place URL -->
                        <li v-if= "this.brand == 'VEP'">
                            <span>
                                <a href="/resources-and-downloads/vep-calculator" target="_blank"> <img class="link-icon" src="/img/icons/vep-product-selector.svg">VEP Product Selector</a>
                            </span>
                        </li>
                        <li v-if= "this.brand == 'ABZ Valve'">
                            <span>
                                <a href="https://bim-catalog.asc-es.com/configurator/valve-configurator" target="_blank"> <img class="link-icon" src="/img/icons/abz-valve-configurator.svg">ASC Valve Configurator</a>
                            </span>
                        </li>
                        <li v-for="brandLink in this.brandLinks">
                            <span>
                                <a :href="brandLink.url">{{ brandLink.text }}</a>
                            </span>
                        </li>
                    </template>

                    <li v-if="catalogUrl">
                        <a :href="catalogUrl" target="_blank"><img class="link-icon" src="/img/icons/cube-regular.svg"> BIM Library Page</a>
                    </li>
                    <li v-if="seisbraceLink">
                        <a :href="seisbraceLink"><i class="fa fa-sitemap link-icon"></i> Seis Brace®</a>
                    </li>
                </ul>

                <hr>

                <h4>Add to Submittal Manager</h4>

                <div v-if="canAdd">
                    <div v-if="showProjects">
                        <div class="select submittal-manager">
                        <a href="/submittal-manager/project" class="new-project" target="_blank"><img class="link-icon" src="/img/icons/plus-circle-regular.svg"> Create New Project</a>
                            <select v-model="selectedSubmittal" size="5">
                                <optgroup v-for="project in projects" :label="project.project.name">
                                    <option  v-for="submittal in project.submittals"
                                        :value="submittal.id"
                                        :class="{added:isAdded(submittal.id)}"
                                        v-text="submittal.name"
                                    />
                                </optgroup>
                            </select>
                        </div>
                    </div>
                    <div v-else>
                        <p class="coach">
                            <a href="/submittal-manager">You have no projects set up.<br>
                            Click here to create one.</a>
                        </p>
                    </div>
                    <div v-if="showAdd">
                        <button v-if="exists" class="button disabled">Successfully Added</button>
                        <save-button v-else
                            :saving="saving"
                            @clicked="add"
                            defaultText="Add Product"
                            duringText="Adding to Submittal"
                            finishedText="Added !"
                        ></save-button>
                    </div>
                </div>

                <div v-if="!canAdd">
                    <p>This product is not available to be added to a submittal.</p>
                </div>

                <hr>
                <h5>Require Additional Assistance?</h5>
                <a :href="moreInfoLink" class="button simple">Request more info</a>
            </div>
        </div>
        <loading v-else></loading>
    </div>

    <div class="add" v-else>
        <div class="submittal log-reg">
            <header v-if="canPrint">
                <span @click="printPage"><img class="link-icon" src="/img/icons/print-regular.svg"><a href="#"> Print</a></span>
            </header>

            <div>
                <h4>Add to Submittal Manager</h4>
                <p>Login or register for an account to access your Submittal Manager</p>
                <a :href="window.AppConfig.loginPath" class="button simple">Login</a>/<a :href="window.AppConfig.registerPath" class="button simple">Register</a>

                <hr>
                <h4>Require Additional Assistance?</h4>
                <a :href="moreInfoLink" class="button simple">Request more info</a>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapActions } from 'vuex';
    import _ from 'lodash';import 
    Favorite from './Favorite.vue';

    export default {
        components: {
            Favorite,
        },
        data() {
            return {
                saving: false,
                selectedProject: '',
                selectedSubmittal: '',
                productRelations: '',
                projects: null
            }
        },
        computed: {
            showProjects() {
                return this.projects.length > 0;
            },
            showSubmittal() {
                this.selectedSubmittal = '';
                return this.selectedProject === '' ? false : true;
            },
            showAdd() {
                return this.selectedSubmittal === '' ? false : true;
            },
            exists() {
                let submittalId = this.selectedSubmittal;
                let exists = false;
                if (this.showAdd && this.productRelations.length != 0) {
                    _.each(this.productRelations, product => {
                        if (parseInt(product.submittalId) == submittalId) {
                            exists = true;
                        }
                    })
                }
                return exists;
            },
            seisbraceLink() {
                let seiesbraceBrands = ['AFCON']; // array of brands requiring the link
                if (seiesbraceBrands.includes(this.brand)) {
                    return '/submittal-manager';
                }
                return '';
            },
            moreInfoLink() {
                return `/company/contact-us?topic=Product Questions&productInfo=${this.figure} - ${this.title}#email`
            },
            canAdd() {
                if (this.hasSubmittal) {
                    return true;
                }

                return false;
            },
            submittalFileUrls() {
                return JSON.parse(this.submittalFileUrl);
            }
        },

        mounted() {
            if (this.user) {
                // moved this to the products/index.vue component
                this
                .getListOfSubmittals()
                .then(response => {
                    this.projects = response;
                });

                this
                .getProductRelations(this.id)
                .then(response => {
                    this.productRelations = response.data;
                });
            }
        },
        methods: {
            add() {
                this.saving = true;

                this
                .saveProduct({
                    submittalID: this.selectedSubmittal,
                    productID: this.id
                })
                .then(() => {
                    this.saving = false;

                    this
                    .getProductRelations(this.id)
                    .then(response => {
                        this.productRelations = response.data;
                    });
                })
                .then(() => {
                    setTimeout(() => this.selectedSubmittal = '', 2500)
                });
            },
            isAdded(submittalId) {
                let added = false;
                if (this.productRelations.length != 0) {
                    _.each(this.productRelations, product => {
                        if (parseInt(product.submittalId) == submittalId) {
                            added = true;
                        }
                    })
                }
                return added;
            },
            hasSubmittals(projectId) {
                if (!this.projects || !this.projects[projectId]) {
                    return false;
                }
                return this.projects[projectId].submittals.length > 0;
            },
            createLink(projectId) {
                return `/submittal-manager/mechanical/${projectId}/information/new`
            },
            printPage() {
                window.print();
            },

            ...mapActions('mechanical', [
                'saveProduct',
                'getProductRelations',
                'getListOfSubmittals' // moved to the products/index.vue component
            ])
        },
        props: ['id', 'user', 'title', 'figure', 'brand', 'brandLinks', 'displayValveConfigurator', 'hasSubmittal', 'submittalFileUrl', 'canPrint', 'catalogUrl']
    }
</script>
